import { httpsCallable } from "firebase/functions";
import { v4 as uuid } from "uuid";
import { functions } from "../../../firebase";

export const queueAnnualMaskEmail = async ({ caseItem, message, isTest = false }) => {
  const response = await httpsCallable(functions, "queueAnnualMaskDoctorEmail")({
    casePath: caseItem.refPath,
    message,
    isTest,
    requestId: uuid(),
  });
  return response.data;
};
